import src from "IMAGE";
export default { src, width: 71, height: 231, blurWidth: 2, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAICAYAAADTLS5CAAAATUlEQVR42k3GLQqAMBiA4Rc8kJ5Og8UirOwCYvUqdjGu+VdFNlcG27648MDD0GjV12rk6rw7WvdhqhRFwCChzMpzixPNMouJnd9u2DcDz0gpNFDaa7IAAAAASUVORK5CYII="};
